
<div class="add-port-panel">
  <div
    v-for="(item, index) in portList"
    :key="item?.key || index"
    class="grid grid-cols-[1fr,1fr,80px] gap-x-2"
  >
    <Input
      :id="`rde-input-port-name-${index}`"
      v-model="item.name"
      :placeholder="
        $t('workspace_rde.rde_detail.placeholder.enter_port_name')
      "
      :rules="[rules.required, rules.name, validateDuplicate('name')]"
      :label="`* ${$t('workspace_rde.rde_detail.label.port_name')}`"
      appendClass="input-text-field-v2 text-details"
    />
    <NumberInput
      :id="`rde-input-port-value-${index}`"
      v-model="item.port"
      format="none"
      :placeholder="$t('workspace_rde.rde_detail.placeholder.port_number')"
      :rules="[rules.required, validatePort, validateDuplicate('port')]"
      :label="`* ${$t('workspace_rde.rde_detail.label.port')}`"
      appendClass="input-text-field-v2 text-details"
      :max="65535"
      :min="0"
    />
    <div class="flex w-3">
      <v-icon
        v-show="portList.length > 1"
        class="h-6 mt-1"
        @click="handleRemoveClick(index)"
      >
        mdi-close
      </v-icon>
    </div>
  </div>
  <div v-if="!portList.length" class="text-xs text-error h-5">
    {{ $t("workspace_rde.rde_detail.message.require_port") }}
  </div>
  <Button class="add-button" size="md" @click="handleAddClick">
    <v-icon>mdi-plus</v-icon>
    {{ $t("workspace_rde.rde_detail.button.add_port") }}
  </Button>
</div>
